module.exports = __webpack_public_path__ + "js/stellarium-web-engine.0728ef9a.wasm";